// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('calculationSeasonyear', {
//         templateUrl: 'views/components/views/calculationSeasonyear/calculationSeasonyear.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['calculationSeasonyearService', 'ttGridFactory', function (calculationSeasonyearService, ttGridFactory) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;

//             vm.model = {
//                 gridReady: false
//             };

//             vm.grid = new ttGridFactory({
//                 rememberId: 'w_calculationseasonyear_grid',
//                 kendo: {
//                     height: '100%',
//                     sortable: true,
//                     aggregate: true,
//                     pager: false,
//                     selectable: false,
//                     filterable: false
//                 }
//             })
//             // .setCustomToolbarButtons([{
//             //     name: 'recalculate',
//             //     text: 'recalculate',
//             //     func: () => updateRecalculation(),
//             //     icon: 'fa-calculator',
//             //     cssClass: 'btn btn-primary im-grid-btn-xs-r',
//             //     translate: true,
//             //     disabled: () => { return; }
//             // }]);
            
//             // #endregion VARIABLES & DEFINITIONS

//             // #region GRID PROCEDURE FUNCTION CALLS

//             async function loadGrid() {
//                 vm.grid.dataTask.loadData = {
//                     method: 2639,
//                     parameters: {}
//                 };

//                 vm.model.gridReady = true;

//                 if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//             }

//             // #endregion GRID PROCEDURE FUNCTION CALLS

//             // #region TOOLBAR BUTTON VALIDATION

//             // function getIsSelectedItems() {
//             //     let dirtyItems = vm.grid.gridfunc.getDirtyRows();
//             //     let isSelectedItems = [];

//             //     dirtyItems.forEach((item) => {
//             //         if (item && item.is_selected === true) isSelectedItems.push(item);
//             //     });

//             //     return isSelectedItems;
//             // }

//             // #endregion TOOLBAR BUTTON VALIDATION

//             // #region TOOLBAR BUTTON FUNCTIONS

//             // function prepareRecalc(items) {
//             //     let promises = [];

//             //     vm.grid.gridfunc.gridProgress(true);

//             //     for (let i = 0; i < items.length; i++) {
//             //         promises.push(calculationSeasonyearService.recalculateGrid({ calculationhead_keyno: items[i].calculationhead_keyno }));
//             //     }

//             //     Promise.all(promises).then(function (response) {
//             //         vm.grid.gridfunc.gridProgress(false);
//             //         vm.grid.gridfunc.rebind();

//             //         Promise.resolve(response);
//             //     }, function (error) {
//             //         console.log('error! error! error! error! error!');

//             //         if (angular.isDefined(error.data) && angular.isString(error.data.message) && error.data.message.length > 0) {
//             //             console.log(error.data.message);

//             //             if (angular.isDefined(error.data.data) && angular.isString(error.data.data.message) && error.data.message !== error.data.data.message) {
//             //                 console.log(error.data.data.message);
//             //             }
//             //         } else {
//             //             if (angular.isDefined(error.data) && angular.isDefined(error.data.data) && angular.isString(error.data.data.message) && error.data.data.message.length > 0) {
//             //                 console.log(error.data.data.message);
//             //             }
//             //         }

//             //         console.dir(error);

//             //         Promise.reject(error);
//             //     });

//             //     return Promise.promise;
//             // }

//             // function updateRecalculation() {
//             //     console.log('Recalculate');
//             //     let items = getIsSelectedItems();

//             //     prepareRecalc(items).then(function (result) {
//             //         console.log('Done');
//             //         console.dir(result);
//             //     });
//             // }

//             // #endregion TOOLBAR BUTTON FUNCTIONS

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 loadGrid();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
